import { api as wiredApi } from './index';

/**
 * This phone as a place InGo rings a rider (InGo `Modules/Push`,
 * `rider/me/push-devices`; background-push piece 1). Registered on every
 * sign-in and app start: the server keeps one row per token, moves it to
 * whoever registered it last, and forgets it when the rider signs out (the
 * session's token goes, and the phone with it), so signing out needs no call
 * from here.
 *
 * Built from its client so a test can hand it a fake; `pushDevicesApi` below
 * is the app's wired copy.
 */
export function createPushDevicesApi({ api, realm = 'rider' }) {
  const path = `/${realm}/me/push-devices`;

  return {
    /**
     * `POST {realm}/me/push-devices`. Answers `{ platform, rings }`: `rings`
     * is false while push is switched off on the server, when offers and
     * updates show only with the app open.
     */
    async register(token, platform) {
      const { data } = await api.post(path, { token, platform });

      return { platform: data?.platform ?? platform, rings: Boolean(data?.rings) };
    },

    /** `DELETE {realm}/me/push-devices/{token}`: this phone is no longer reached (push turned off). */
    async forget(token) {
      await api.delete(`${path}/${encodeURIComponent(token)}`);
    },
  };
}

/** A rider's phone, for offers. */
export const pushDevicesApi = createPushDevicesApi({ api: wiredApi });

/** A client's phone, for their delivery updates (Rio, 2 Oct 2026). */
export const clientPushDevicesApi = createPushDevicesApi({ api: wiredApi, realm: 'customer' });
